/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Table_MetadataInputs */

const es_admin_traces_table_metadata = /** @type {(inputs: Admin_Traces_Table_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos`)
};

const en_admin_traces_table_metadata = /** @type {(inputs: Admin_Traces_Table_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

/**
* | output |
* | --- |
* | "Metadata" |
*
* @param {Admin_Traces_Table_MetadataInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_table_metadata = /** @type {((inputs?: Admin_Traces_Table_MetadataInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Table_MetadataInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_table_metadata(inputs)
	return en_admin_traces_table_metadata(inputs)
});
export { admin_traces_table_metadata as "admin.traces.table.metadata" }